/**
 * Sidebar Layout Tailwind Constants
 * 
 * Semantic naming for sidebar-specific layout patterns.
 */

export const SIDEBAR_LAYOUT = {
  // Desktop sidebar container
  desktop: 'hidden md:flex md:flex-col md:h-screen border-r border-border bg-card',
  /**
   * Always-visible sidebar column (any width). Use for Chrome extension sidepanel/popup so chat
   * history stays inline instead of a drawer + floating menu button.
   */
  desktopSplitHost: 'flex flex-col h-full min-h-0 border-r border-border bg-card',
  desktopContent: 'flex flex-col flex-1 min-h-0 overflow-hidden',

  // Mobile drawer container
  mobileDrawer: 'md:hidden',

  // Sidebar header - logo, new chat button, settings
  header: 'flex items-center justify-between p-4 border-b border-border flex-shrink-0',
  headerTitle: 'text-lg font-semibold text-foreground',
  headerButton: 'p-2 hover:bg-muted rounded-lg transition-colors',

  // Tabs bar - Active, Archived, All tabs
  tabsBar: 'flex gap-2 p-4 border-b border-border flex-shrink-0',
  tab: 'px-3 py-1 rounded-md text-sm font-medium transition-colors hover:bg-muted',
  tabActive: 'bg-primary text-primary-foreground',
  tabInactive: 'text-muted-foreground hover:text-foreground',
  tabCount: 'ml-1 text-xs opacity-75',

  // Chat list container
  chatList: 'flex-1 min-h-0 overflow-y-auto',
  chatListEmpty: 'flex items-center justify-center h-full text-muted-foreground',

  // Chat item - individual chat in list
  chatItem: 'px-4 py-2 hover:bg-muted cursor-pointer transition-colors border-l-2 border-transparent',
  chatItemActive: 'bg-primary/10 border-l-2 border-primary text-primary font-medium',
  chatItemTitle: 'text-sm font-medium truncate',
  chatItemDate: 'text-xs text-muted-foreground mt-1',

  // Chat item actions (restore, delete)
  chatItemActions: 'flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity',
  chatItemAction: 'p-1 hover:bg-destructive/10 rounded transition-colors',

  // Resize handle for desktop sidebar
  resizeHandle: 'absolute right-0 top-0 h-full w-1 cursor-col-resize hover:bg-primary/50 transition-colors',

  // Collapse button
  collapseButton: 'p-2 hover:bg-muted rounded-lg transition-colors',
};

// Sidebar header button styles
export const SIDEBAR_BUTTONS = {
  newChat: 'flex items-center gap-2 px-3 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium text-sm',
  settings: 'p-2 hover:bg-muted rounded-lg transition-colors',
  capabilities: 'p-2 hover:bg-muted rounded-lg transition-colors',
};

// Sidebar loading states
export const SIDEBAR_LOADING = {
  skeleton: 'animate-pulse bg-muted rounded-lg',
  skeletonItem: 'h-12 mb-2',
};
